module.exports = __webpack_public_path__ + "img/h-3.529068de.svg";